// Redux store for @gfo/web. Built from the platform factory so auth, STOMP,
// notifications, jobs, and UI slices are pre-wired. GFO-specific slices (none
// yet) would be passed via `extraReducers`.
//
// Per docs/podium/core/STORE.md, base slices cover app state only — server
// entity data belongs in TanStack Query, not Redux.

import {
  createPodiumStore,
  type PodiumStore,
  type RootState,
  type AppDispatch,
} from '@podium/platform/store'

export const store: PodiumStore = createPodiumStore()

export type { RootState, AppDispatch }
